import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/[locale]/(web)/spark/auction/page.tsx");
